import * as startBackgroundDirective from './start-background.directive';
import * as registerService from './register.service';


export default angular.module('register.components.background', [
  'ngMaterial'
])
  .directive(startBackgroundDirective.name, startBackgroundDirective.default)
  .service(registerService.name, registerService.default)
  .name;



// WEBPACK FOOTER //
// ./components/start-background/start-background.module.js